import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { stateMerge } from 'vue-object-merge';
import news from '@/storeModules/news';
import userDetails from '@/storeModules/userDetails';
import clientConfig from '@/storeModules/clientConfig';
import auth from '@/storeModules/auth';
import analytics from '@/storeModules/analytics';
import helpTopics from '@/storeModules/helpTopics';

const code = process.env.VUE_APP_APICODE;
const apiUrl = process.env.VUE_APP_APIADDRESS;

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        news,
        userDetails,
        auth,
        clientConfig,
        analytics,
        helpTopics,
    },
    state: {
        ui: {
            dataLoaded: false,
            showEnquriesModal: false,
            showAdditionalInformationModal: false,
            loadingDashboardData: false,
            showFooter: true,
            loggedIn: false,
            showLoginRegisterModal: false,
            showMenuMobile: false,
            showPopUp: false,
            loader: {
                show: false,
                message: null,
            },
            showServicePeriodHelp: true,
            // dashboardData: {
            //     basicData: {
            //         latestUnconfirmedAddress: null,
            //     },
            // },
        },
        countryList: ['Ireland', 'Scotland', 'United Kingdom', 'Wales'],
        documents: [],
        illustrations: {},
        postLogin: {},
        loggedInUser: '',
        showLoginPrompt: false,
    },
    getters: {
        // userDetails: s => s.userDetails,
        loggedInUser: s => s.loggedInUser,
        showLoginPrompt: s => s.showLoginPrompt,
        getUserActivity: (state) => {
            if (state.ui.dashboardData && state.ui.dashboardData.activity) {
                return state.ui.dashboardData.activity;
            }
            return [];
        },
    },
    mutations: {
        updatePostLogin (state, payload) {
            Vue.set(state, 'postLogin', payload);
        },
        updateUserDocuments (state, payload) {
            Vue.set(state, 'documents', payload);
        },
        updateIllustrations (state, payload) {
            Vue.set(state, 'illustrations', payload);
        },
        toggleEnquiriesModal (state, status) {
            Vue.set(state.ui, 'showEnquriesModal', status);
        },
        toggleAdditionalInformationModal (state, status) {
            Vue.set(state.ui, 'showAdditionalInformationModal', status);
        },
        loadingDashboardData (state, status) {
            Vue.set(state.ui, 'loadingDashboardData', status);
        },
        setLoggedInUser (state, user) {
            state.loggedInUser = user;
        },
        setShowLoginPrompt (state, val) {
            state.showLoginPrompt = val;
        },
        closeFooter (state) {
            Vue.set(state.ui, 'showFooter', false);
        },
        toggleLoginRegisterModal (state, status) {
            Vue.set(state.ui, 'showLoginRegisterModal', status);
        },
        setLogin (state, status) {
            Vue.set(state.ui, 'loggedIn', status);
            Vue.set(state.ui, 'showLoginRegisterModal', false);
        },
        updateDashboardData (state, value) {
            Vue.set(state.ui, 'dashboardData', value);
        },
        updateDashboardDataUserDetails (state, value) {
            Vue.set(state.ui.dashboardData.basicData, 'maritalStatus', value.maritalStatus);
            Vue.set(state.ui.dashboardData.basicData, 'spouseDoB', value.spouseDoB);
            Vue.set(state.ui.dashboardData.basicData, 'spouseName', value.spouseName);
            Vue.set(state.ui.dashboardData.basicData, 'dateOfMarriage', value.dateOfMarriage);
        },
        updateDocuments (state, value) {
            Vue.set(state.ui.dashboardData, 'documents', value);
        },
        clearDashboardData (state) {
            Vue.set(state.ui, 'dashboardData', null);
        },
        toggleMenuMobile (state, status) {
            Vue.set(
                state.ui,
                'showMenuMobile',
                // eslint-disable-next-line eqeqeq
                status != undefined ? status : !state.ui.showMenuMobile,
            );
        },
        logoutUser (state) {
            Vue.set(state, 'loggedInUser', '');
        },
        setDataLoaded (state, val) {
            state.ui.dataLoaded = val;
        },
        setLoader (state, payload) {
            Vue.set(state.ui, 'loader', payload);
        },
        hideServicePeriodHelp (state) {
            Vue.set(state.ui, 'showServicePeriodHelp', false);
        },
        updateAddressDetails (state, payload) {
            stateMerge(state.ui.dashboardData.basicData, payload, 'latestUnconfirmedAddress', false);
            // Vue.set(state, 'latestUnconfirmedAddress', payload);
        },

        updatePopUp (state, payload) {
            Vue.set(state.ui, 'showPopUp', payload);
        },
        setEcomsPreference (state, payload) {
            Vue.set(state.ui.dashboardData.basicData, 'optOutOfEcom', payload);
        },
        setPayslipsByPostPreference (state, payload) {
            Vue.set(state.ui.dashboardData.basicData, 'receiveOnlinePayslips', payload);
        },
        setOptOutOfPostalPayslips (state, payload) {
            Vue.set(state.ui.dashboardData.basicData, 'optOutOfPostalPayslips', payload);
        },
    },
    actions: {
        getPostLogin ({ commit }) {
            return axios.get(`${apiUrl}/GetPostLoginInfo?code=${code}`).then((response) => {
                commit('updatePostLogin', response.data);
            });
        },
        getDashboardData ({ commit, dispatch, state }) {
            const getIsGetDashboardDataSlow = this.getters['auth/getIsGetDashboardDataSlow'];
            let loadingText = 'Loading your data...';
            if (getIsGetDashboardDataSlow) {
                loadingText = 'Please wait while we generate your personalised pension forecast. Do not refresh your browser.';
            }

            return new Promise((resolve) => {
                if (state.documents.length < 1 && Object.keys(state.illustrations).length < 1) {
                    commit('setLoader', { show: true, message: loadingText });
                    dispatch('getAllDashboardData').then(() => {
                        commit('setLoader', { show: false, message: null });
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
        },
        clearDashboardData ({ commit }) {
            commit('clearDashboardData');
        },
        getDocuments ({ commit }) {
            return axios.get(`${apiUrl}/GetDocuments?code=${code}`).then((response) => {
                commit('updateDocuments', response.data);
            });
        },
        getAllDashboardData ({ commit }) {
            return axios.get(`${apiUrl}/GetDashboardData?code=${code}`).then((response) => {
                commit('updateDashboardData', response.data);
            });
        },
        updateUserDetails ({ commit }, updateObj) {
            commit('updateDashboardDataUserDetails', updateObj);
        },
        logoutUser ({ commit }) {
            commit('logoutUser');
        },
        updateEcomsPreference ({ commit }, preference) {
            commit('setEcomsPreference', preference);
        },
        updatePayslipsByPostPreference ({ commit }, preference) {
            commit('setPayslipsByPostPreference', preference);
        },
        updateOptOutOfPostalPayslipsPreference ({ commit }, preference) {
            commit('setOptOutOfPostalPayslips', preference);
        },
    },
});
